import Comment from './comment'

export default class Inquiry {
  readonly id: number
  readonly title: string
  readonly body: string
  readonly content: string
  readonly createdAt: string
  readonly updatedAt: string
  readonly commentCount: string
  comments: Comment[] = []
  showCommentForm: boolean = false
  isEditing: boolean = false

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.title = data.title
    this.body = data.body
    this.content = data.content
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.commentCount = data.commentCount
    if (data.comments) {
      this.comments = data.comments.map(element => new Comment(element))
    }
  }
}
